import React, {Component} from 'react';
import {forEachObj, mapObjectToArray, objectMerge} from "../lib/tools";
import {Button} from "./common/common";
import {Modal} from "./common/modal";
import {reduxWrapper} from "../globalState";

import LockOpenIcon from "../resources/icons/lockOpen.svg";
import Bg5 from "../resources/images/cocktailFive.png";
import Bg1 from "../resources/images/cocktailOne.png";


const {Provider, Consumer} = React.createContext();
export const PopupConsumer = Consumer;

const popupPresets = {
	confirm: {
		text: "Click OK to confirm",
		buttons: {
			"OK": "ok",
			"Annuler": "cancel"
		},
		callbacks: {
			ok: ({hide}) => hide(),
			cancel: ({hide}) => hide()
		}
	},
	loginPrompt: {
		icon: LockOpenIcon,
		text: "Vi vil rigtig gerne gemme din fest for dig, men du bliver nødt til at logge ind først.",
		buttons: {
			cancel: "Nej tak",
			login: "God ide"
		},
		background: Bg5,
		callbacks: {
			login: ({hide, history}) => {
				history.push("/log-ind");
				hide();
			},
			cancel: ({hide}) => hide()
		}
	},
	partyTransfer: {
		text: "Du er nu logget ind. Du var igang med en fest på din gæstekonto. Vil du tilføje den til din bruger?",
		buttons: {
			cancel: "Nej tak",
			ok: "Ja, gerne"
		},
		background: Bg1
	}
};

class PopupManagerRender extends Component {
	
	constructor(props) {
		super(props);
		
		this.hide = () => {
			this.setState({popup: null})
		};
		
		this.createPopup = ({preset, text, icon, buttons = {}, callbacks = {}, background}) => {
			let popup = {};
			
			if (preset && popupPresets.hasOwnProperty(preset)) {
				popup = {...popupPresets[preset]};
				
				if (preset === "loginPrompt") {
					this.setState({loginPrompt: true})
				}
				
			}
			
			popup.text = text || popup.text;
			popup.icon = icon || popup.icon;
			popup.background = background || popup.background;
			
			
			const newButtons = objectMerge(popup.buttons || {}, buttons);
			const newCallbacks = objectMerge(popup.callbacks || {}, callbacks);
			
			forEachObj(newButtons, (x, i) => {
				let callback;
				if (!newCallbacks.hasOwnProperty(i))
					callback = ({hide}) => hide();
				else
					callback = newCallbacks[i];
				newButtons[i] = {
					callback: callback,
					text: x
				};
			});
			popup.buttons = newButtons;
			delete popup.callbacks;
			
			this.setState({popup: popup});
		};
		
	}
	
	state = {
		popup: null,
		loginPrompt: false
	};
	
	render() {
		const {children, userId, history} = this.props;
		const {popup, loginPrompt} = this.state;
		
		return (
			<Provider value={{createPopup: this.createPopup, loginPrompt, userId}}>
				{children}
				{popup && <Popup {...popup} history={history} onHide={() => this.setState({popup: null})}/>}
			</Provider>
		);
	}
}

const PopupManager = reduxWrapper("getUserId")(PopupManagerRender);

const Popup = ({text, buttons, onHide, history, className, icon, background}) => (
	<Modal
		onHide={() => buttons[Object.keys(buttons)[0]].callback({hide: onHide, history})}
		className={className}
		icon={icon}
		background={background}
	>
		<div className="popupContentWrapper">
			<p>{text}</p>
			<div className="buttons">
				{mapObjectToArray(buttons, (x, k) =>
					<Button className={k} key={k}
					        onClick={() => x.callback({hide: onHide, history})}>{x.text}</Button>)
				}
			</div>
		</div>
	</Modal>
);

export default PopupManager;



// WEBPACK FOOTER //
// ./src/components/popups.js